import api from './api';
import type { OperatoreRuolo } from '../types';

// Il tipo canonico vive in `types/index.ts` accanto a `UserProfile`, che
// ora lo trasporta: qui viene solo ri-esportato per i consumatori storici.
export type { OperatoreRuolo };

export interface Operatore {
  operatoreId: string;
  email: string;
  nome: string;
  cognome: string;
  telefono?: string | null;
  ruolo: OperatoreRuolo;
  ruoloLabel: string;
  attivo: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface OperatoreCreate {
  email: string;
  nome: string;
  cognome: string;
  telefono?: string;
  ruolo: OperatoreRuolo;
  password: string;
}

export interface OperatoreUpdate {
  nome?: string;
  cognome?: string;
  telefono?: string;
  ruolo?: OperatoreRuolo;
  attivo?: boolean;
  password?: string;
}

export const RUOLO_DESCRIPTIONS: Record<OperatoreRuolo, { label: string; desc: string }> = {
  'vedi-sito': {
    label: 'Solo visualizzazione',
    desc: 'Può navigare il catalogo e vedere prezzi, NON aggiunge prodotti al carrello.',
  },
  'crea-carrello': {
    label: 'Crea carrello',
    desc: 'Può aggiungere articoli al carrello e preparare un ordine, ma NON lo invia.',
  },
  'crea-ordine': {
    label: 'Crea ordine',
    desc: 'Può preparare e inviare ordini a nome dell\'azienda.',
  },
};

export const operatoriService = {
  list: async (): Promise<Operatore[]> => {
    const { data } = await api.get<Operatore[]>('/api/clienti/me/operatori');
    return data;
  },
  create: async (payload: OperatoreCreate): Promise<Operatore> => {
    const { data } = await api.post<Operatore>('/api/clienti/me/operatori', payload);
    return data;
  },
  update: async (operatoreId: string, payload: OperatoreUpdate): Promise<Operatore> => {
    const { data } = await api.patch<Operatore>(`/api/clienti/me/operatori/${operatoreId}`, payload);
    return data;
  },
  remove: async (operatoreId: string): Promise<void> => {
    await api.delete(`/api/clienti/me/operatori/${operatoreId}`);
  },
};
